export default "__VITE_ASSET__988f452b__"